import React from 'react';
import ReactDOM from 'react-dom/client';

// Styles
import './index.css';
import 'swiper/css/bundle';

// Components
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
